import { render, staticRenderFns } from "./CommissionShow.vue?vue&type=template&id=3bf90d36&"
import script from "./CommissionShow.vue?vue&type=script&lang=js&"
export * from "./CommissionShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports